import { HashRouter as Router, Navigate, Route, Routes } from 'react-router-dom'

import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import ContactAddress from './components/ContactPage/ContactBox/ContactAddress/ContactAddress'
import ContactAddressDetail from './components/ContactPage/ContactBox/ContactAddress/ContactAddressDetail/ContactAddressDetail'
import CreateContact from './components/ContactPage/ContactBox/ContactAddress/CreateContact/CreateContact'
import EditContact from './components/ContactPage/ContactBox/ContactAddress/EditContact/EditContact'
import ImportFile from './components/ContactPage/ContactBox/ContactAddress/ImportFile/ImportFile'
import ContactBox from './components/ContactPage/ContactBox/ContactBox'
import ManageGroup from './components/ContactPage/ContactBox/ContactGroup/ContactGroup'
import CreateGroup from './components/ContactPage/ContactBox/ContactGroup/CreateGroup/CreateGroup'
import EditGroup from './components/ContactPage/ContactBox/ContactGroup/EditGroup/EditGroup'
import ContactPage from './components/ContactPage/ContactPage'
import Header from './components/Header/Header'
import LoginBox from './components/LoginBox/LoginBox'
import CropImageUploader from './components/UtilComponent/level_3/CropImageUploader/CropImageUploader'
import { resetColor } from './slices/settingSlice'

const App = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(resetColor())
  }, [dispatch])

  return (
    <div className="stack">
      <Router>
        <Header />
        <Routes>
          <Route path="/login" element={<LoginBox />} />
          <Route path="" element={<ContactPage />}>
            <Route path="/" element={<ContactBox />}>
              <Route path="contactAddress" element={<ContactAddress />}>
                <Route path="createContact" element={<CreateContact />} />
                <Route path="ImportFile" element={<ImportFile />} />
              </Route>
              <Route path="contactGroup" element={<ManageGroup />}>
                <Route path="createGroup" element={<CreateGroup />} />
              </Route>
            </Route>
            <Route
              path="contactAddress/:id"
              element={<ContactAddressDetail />}
            />
            <Route
              path="uploadProfileImage/:id"
              element={<CropImageUploader />}
            />
            <Route path="contactAddress/:id/edit" element={<EditContact />} />
            <Route path="groups/:id" element={<EditGroup />} />
          </Route>
          <Route index element={<Navigate replace to="/contactAddress" />} />
          <Route path="*" element={<Navigate replace to="/contactAddress" />} />
        </Routes>
      </Router>
    </div>
  )
}

export default App
